import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

class HelmetHead extends Component {
	// componentWillReceiveProps(nextProps){
	//     console.log('componentWillReceiveProps', nextProps)
	// }

	render() {
		const { siteInfo, title } = this.props;
		const finalTitle = (!!siteInfo.site ? siteInfo.site.title + " | " : "") + title;

		// console.log('rendering helmethead')

		return (
			<Helmet
			// onChangeClientState={(newState) => console.log('Change head:', finalTitle)}
			>
				<title>{finalTitle}</title>
			</Helmet>
		);
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo
	};
};

export default connect(mapStateToProps)(HelmetHead);



// WEBPACK FOOTER //
// ./src/components/utils/HelmetHead.js